import { render, staticRenderFns } from "./ProjectViewer.vue?vue&type=template&id=5c472167&scoped=true&"
import script from "./ProjectViewer.vue?vue&type=script&lang=js&"
export * from "./ProjectViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c472167",
  null
  
)

export default component.exports